import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restores window scroll to the top on every route change.
 * Mounted once at the root inside <BrowserRouter>. Skips restoration when
 * the URL includes a `#hash` (in-page anchor).
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}
